export function slugify(title: string): string {
  return title
    .toLowerCase()
    .replace(/[\s/]+/g, '-') // spaces and slashes -> hyphen
    .replace(/[^a-z0-9-]/g, '') // strip unsafe chars
    .replace(/-+/g, '-') // collapse multiple hyphens
    .replace(/^-|-$/g, ''); // trim leading/trailing hyphens
}

export function slugToKey(slug: string): string {
  return slugify(slug).replace(/-/g, '_');
}
